import React from "react";
import classNames from "classnames";

export type ButtonProps = {
  active?: boolean;
} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export const Button = ({
  active,
  children,
  className,
  ...rest
}: ButtonProps) => {
  const internalClassName = classNames(className, {
    "gpc__button--is-active": active,
  }, "gpc__button");

  return (
    <button className={internalClassName} {...rest}>
      {children}
    </button>
  );
};

export default Button;
